var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4714 10.4712C12.2111 10.7316 11.789 10.7316 11.5286 10.4712L8.00002 6.94265L4.47142 10.4712C4.21107 10.7316 3.78897 10.7316 3.52862 10.4712C3.26827 10.2109 3.26827 9.78878 3.52862 9.52843L7.52862 5.52843C7.78897 5.26808 8.21108 5.26808 8.47142 5.52843L12.4714 9.52843C12.7318 9.78878 12.7318 10.2109 12.4714 10.4712Z",
    fill: "#0C0D0D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.f8ef07fc4003aa5ed271cf79f3a5a2ef.svg";
export { ForwardRef as ReactComponent };